export const HighlightText = ({ text }: { text: string }) => {
    return <mark className="bg-green-pro">{text}</mark>;
};
